import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './RecognitionOperationsTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function RecognitionOperationsTab() {
  const [operations, setOperations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOperations();
    // Обновляем данные каждые 10 секунд
    const interval = setInterval(fetchOperations, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchOperations = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/recognition-operations`);
      setOperations(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке операций распознавания: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '-';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  if (loading && operations.length === 0) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="recognition-operations-tab">
      <div className="tab-header">
        <h2>Операции распознавания</h2>
        <button className="btn btn-secondary" onClick={fetchOperations}>
          🔄 Обновить
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="info-box">
        <p>📋 Здесь отображаются операции распознавания, которые находятся в процессе обработки. 
           Операции автоматически удаляются после завершения распознавания.</p>
        <p>🔄 Данные обновляются автоматически каждые 10 секунд.</p>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Имя файла</th>
              <th>Operation ID</th>
              <th>S3 URL</th>
              <th>Дата создания</th>
            </tr>
          </thead>
          <tbody>
            {operations.length === 0 ? (
              <tr>
                <td colSpan="5" className="empty-state">
                  Нет активных операций распознавания. Все операции завершены или еще не созданы.
                </td>
              </tr>
            ) : (
              operations.map((operation) => (
                <tr key={operation.id}>
                  <td>{operation.id}</td>
                  <td className="filename-cell">
                    <span className="filename-badge">{operation.filename}</span>
                  </td>
                  <td className="operation-id-cell">
                    <code className="code-text">{truncateText(operation.operation_id, 30)}</code>
                  </td>
                  <td className="url-cell">
                    <a 
                      href={operation.s3_url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="url-link"
                      title={operation.s3_url}
                    >
                      {truncateText(operation.s3_url, 40)}
                    </a>
                  </td>
                  <td>{formatDate(operation.created_at)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {operations.length > 0 && (
        <div className="stats-box">
          <span className="stat-item">
            Всего операций: <strong>{operations.length}</strong>
          </span>
        </div>
      )}
    </div>
  );
}

export default RecognitionOperationsTab;

